import 'firebase/compat/messaging';
import 'firebase/messaging';

import 'firebase/compat/auth';
import 'firebase/compat/firestore';

import { getAnalytics } from 'firebase/analytics';
import firebase from 'firebase/compat/app';

const FIREBASE_CONFIG = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const getFirebaseConfig = () => {
  if (!FIREBASE_CONFIG || !FIREBASE_CONFIG.apiKey) {
    throw new Error(
      'No Firebase configuration object provided.' +
        '\n' +
        "Add your web app's configuration object to firebase-config.js"
    );
  } else {
    return FIREBASE_CONFIG;
  }
};

export const firebaseApp = firebase.initializeApp(getFirebaseConfig());
export const messaging = firebase.messaging();
export const analytics = getAnalytics(firebaseApp);
